import { LicenceDto } from "@libs/api/gateways/plt/plt-gateway.dtos";

import { LicenceFormValues } from "./LicenceFormDialog.types";

export const getLicenceFormValues = (dto: LicenceDto): LicenceFormValues => {
  return {
    productId: dto.productId,
    userId: dto.userId,
    username: dto.username,
    expiryDate: dto.expiryDate
      ? new Date(
          new Date(dto.expiryDate).setDate(
            new Date(dto.expiryDate).getDate() - 1
          )
        )
      : undefined,
    isActive: !dto.isInactive,
    licenceTypeCode: dto.licenceTypeCode,
    name: dto.name,
    displayName: dto.displayName,
    description: dto.description,
    doNotRenew: dto.doNotRenew
  };
};
